import React from 'react';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import Spacer from '../../../components/Spacer/Spacer';
import FlexWrapper from '../../../components/FlexWrapper/FlexWrapper';
import { Plus, Trash } from '../../../components/Svg/Svg';
import { generateId } from '../../../utils/helpFunctions';
import CustomInput from '../../../components/CustomInput';
import { Col } from 'antd';
import { useSelector } from 'react-redux';
import { oneContact } from '../../../redux/slices/contactSlice';

export default function ContactEditors({
    flag,
    data,
    onChange,
    onAddInfoBox,
    onRemoveInfoBox,
    onChangeInfoBox,
    errors,
}) {
    const contact = useSelector(oneContact);

    const onEditorChange = (editor, id) => {
        const data = editor.getData();

        onChange(data, flag, id);
    };

    const onInfoBoxChange = (data, id, field) => {
        onChangeInfoBox({
            text: field === 'title' ? data : data?.getData(),
            flag,
            id,
            field,
        });
    };

    const infoBoxes = data[flag]?.info_boxes?.map((el) => {
        if (!el?.id) {
            el.id = generateId();
        }
        return el;
    });

    const indexOfContactDetail = contact?.details?.findIndex(
        (el) => el.lang_code.toLowerCase() === flag,
    );

    return (
        <div>
            <div>
                <CKEditor
                    editor={Editor}
                    id={`content_${flag}`}
                    config={{
                        toolbar: {
                            items: [
                                'undo',
                                'redo',
                                'heading',
                                'bold',
                                'italic',
                                'link',
                                'bulletedList',
                                'numberedList',
                                'insertTable',
                                'outdent',
                                'indent',
                                'blockQuote',
                                'htmlEmbed',
                            ],
                        },
                        link: {
                            addTargetToExternalLinks: true,
                            decorators: [
                                {
                                    mode: 'manual',
                                    label: 'Downloadable',
                                    attributes: {
                                        download: 'download',
                                    },
                                },
                            ],
                        },
                    }}
                    data={data[flag]?.content}
                    onChange={(_, editor) =>
                        onEditorChange(editor, `content_${flag}`)
                    }
                />
            </div>
            <Spacer size={12} />
            <div>
                <div>
                    {infoBoxes?.map((el, i) => (
                        <div key={el.id}>
                            <FlexWrapper justify="space-between" align="center">
                                <p
                                    className="input-label"
                                    style={{ margin: 0 }}
                                >
                                    Info box
                                </p>
                                <button
                                    className="button__link"
                                    type="button"
                                    onClick={() => onRemoveInfoBox(flag, el.id)}
                                >
                                    <FlexWrapper
                                        align="center"
                                        justify="center"
                                    >
                                        <Trash /> &nbsp;&nbsp;Remove
                                    </FlexWrapper>
                                </button>
                            </FlexWrapper>
                            <Spacer size={5} />
                            <Col span={10}>
                                <div className="form__item-wrapper">
                                    <CustomInput
                                        id="title"
                                        placeholder="Enter infobox title"
                                        onInputChange={(e) =>
                                            onInfoBoxChange(
                                                e.target.value,
                                                el.id,
                                                'title',
                                            )
                                        }
                                        inputValue={el?.title}
                                        labelText="Title"
                                        width="100%"
                                        errorText={
                                            errors?.[
                                                `details.${indexOfContactDetail}.info_boxes.${i}.title`
                                            ]
                                        }
                                    />
                                </div>
                            </Col>
                            <CKEditor
                                editor={Editor}
                                id={el.id}
                                config={{
                                    toolbar: {
                                        items: [
                                            'undo',
                                            'redo',
                                            'heading',
                                            'bold',
                                            'italic',
                                            'link',
                                            'bulletedList',
                                            'numberedList',
                                            'insertTable',
                                            'outdent',
                                            'indent',
                                            'blockQuote',
                                            'htmlEmbed',
                                            'fontColor',
                                        ],
                                    },
                                    link: {
                                        addTargetToExternalLinks: true,
                                        decorators: [
                                            {
                                                mode: 'manual',
                                                label: 'Downloadable',
                                                attributes: {
                                                    download: 'download',
                                                },
                                            },
                                        ],
                                    },
                                    fontColor: {
                                        colors: [
                                            {
                                                color: '#1C1C1C',
                                                label: 'Gray-9',
                                            },
                                            {
                                                color: '#3C3C3C',
                                                label: 'Gray-8',
                                            },
                                            {
                                                color: '#5B5B5B',
                                                label: 'Gray-7',
                                            },
                                            {
                                                color: '#7F7F7F',
                                                label: 'Gray-6',
                                            },
                                            {
                                                color: '#AFAFAF',
                                                label: 'Gray-5',
                                            },
                                            {
                                                color: '#43404F',
                                                label: 'Purple-9',
                                            },
                                            {
                                                color: '#7B7895',
                                                label: 'Purple-8',
                                            },
                                            {
                                                color: '#A29FB7',
                                                label: 'Purple-7',
                                            },
                                            {
                                                color: '#CDCCDA',
                                                label: 'Purple-6',
                                            },
                                            {
                                                color: '#D9D8E6',
                                                label: 'Purple-5',
                                            },
                                            {
                                                color: '#E6E6E6',
                                                label: 'Gray-3',
                                            },
                                            {
                                                color: '#F0F0F1',
                                                label: 'Gray-2',
                                            },
                                            {
                                                color: '#F8F8F8',
                                                label: 'Gray-1',
                                            },
                                            {
                                                color: '#E4E3EC',
                                                label: 'Purple-4',
                                            },
                                            {
                                                color: '#ECEAF3',
                                                label: 'Purple-3',
                                            },
                                            {
                                                color: '#F5F4F9',
                                                label: 'Purple-2',
                                            },
                                            {
                                                color: '#F9F9FC',
                                                label: 'Purple-1',
                                                hasBorder: true,
                                            },
                                            {
                                                color: '#FFFFFF',
                                                label: 'White',
                                                hasBorder: true,
                                            },
                                        ],
                                    },
                                }}
                                data={el.content}
                                onChange={(_, editor) =>
                                    onInfoBoxChange(editor, el.id, 'content')
                                }
                            />
                            <Spacer size={12} />
                        </div>
                    ))}
                </div>
                <button
                    className="button__link"
                    type="button"
                    onClick={() => onAddInfoBox(flag)}
                >
                    <FlexWrapper align="center" justify="center">
                        <Plus />
                        &nbsp;&nbsp;Add info box
                    </FlexWrapper>
                </button>
            </div>
        </div>
    );
}
